export const WAITTIME = "WAITTIME";
